import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Timer from './Timer';

import up from './assets/keyboard/UP.png';
import down from './assets/keyboard/DWN.png';
import left from './assets/keyboard/LFT.png';
import right from './assets/keyboard/RT.png';
import space from './assets/keyboard/SPACE.png';

import './KeyboardHints.css';

class KeyboardHintListener extends Component {
    constructor(props) {
        super(props);
        this.listener = () => {
            this.props.on_interaction();
        }
        window.addEventListener('click', this.listener, true);
        window.addEventListener('keydown', this.listener, true);
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.listener, true);
        window.removeEventListener('keydown', this.listener, true);
    }
    render() {
        return null;
    }
}
export default class KeyboardHints extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dismissed: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible && !this.props.visible) {
            this.setState({dismissed: false});
        }
    }

    render() {
        const {dismissed} = this.state;
        const {visible} = this.props;

        const is_visible = visible && !dismissed;

        let container_class = "KeyboardHints App-layer";
        if (!is_visible) {
            container_class += ' KeyboardHints-left';
        }
        const no_events_style = {pointerEvents: 'none'};
        return <div className={container_class} style={no_events_style}>
            <KeyboardHintListener on_interaction={() => this.setState({dismissed: true})} />
            <img src={up} className="App-layer" style={no_events_style} />
            <img src={down} className="App-layer" style={no_events_style} />
            <img src={left} className="App-layer" style={no_events_style} />
            <img src={right} className="App-layer" style={no_events_style} />
            <img src={space} className="App-layer" style={no_events_style} />
        </div>

        return null;
    }
}
KeyboardHints.propTypes = {
    visible: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/KeyboardHints.js